export const setNameRowLodging = (index?: number) =>
  `schedulesAddLodging.${index}`
